import processRestService from '../services/process/ProcessRestService'
import { todayLocalDate, toLocalDateInput } from '../services/common/UtilsFunctions'
import { PROCESS_STATUS } from '../services/process/ProcessStatus'

const getDefaultState = () => {
  return {
    processes: [],
    filteredProcesses: [],
    dialogActived: false,
    defaultItem: {
      id: -1,
      processNumber: null,
      referenceName: '',
      date: todayLocalDate(),
      obs: null,
      status: PROCESS_STATUS.DRAFT,
      processedCommodities: [],
      naturalCommodities: []
    },
    selectedItem: null,
    processNumberList: null
  }
}

const state = getDefaultState()

const getters = {
  getProcesses: state => state.processes,
  getDefaultItem: state => state.defaultItem,
  isDialogActived: state => state.dialogActived,
  getSelectedItem: state => state.selectedItem,
  getFilteredProcesses: state => state.filteredProcesses,
  getProcessNumberList: state => state.processNumberList
}

const actions = {
  async getProcesses (context) {
    try {
      let data = await processRestService.getProcesses()
      context.commit('setProcesses', data)
    } catch (e) {
      console.error('Vuex - Action: getProcesses', 'Error fetching Processes')
    }
  },
  async getProcessNumberList (context) {
    try {
      let data = await processRestService.getProcessNumberList()
      context.commit('setProcessNumberList', data)
    } catch (error) {
      console.log('Vuex - Action: getProcessNumberList', 'Error fetching income number list')
    }
  },
  async addOrEditProcess (context, item) {
    let isEdit = (item.id > 0)
    let message = 'Parte de Proceso ' + ((isEdit) ? 'Editado' : 'Agregado') + ' Exitosamente.'
    let snackBarContent = {actived: true, message: message, color: 'success'}
    try {
      let savedItem
      if (isEdit) {
        savedItem = await processRestService.editProcess(item)
      } else {
        savedItem = await processRestService.addProcess(item)
      }
      return savedItem
    } catch (error) {
      console.error('Vuex - Action: addOrEditProcess', error)
      message = 'Error ' + ((isEdit) ? 'Editando' : 'Agregando') + ' Parte de Proceso.'
      snackBarContent = {actived: true, message: message, color: 'error'}
      throw error
    } finally {
      context.commit('setSnackBarStatus', snackBarContent, {root: true})
    }
  },
  async updateStatus (context, { id, status }) {
    try {
      await processRestService.updateStatus(id, status)
      await context.dispatch('getProcesses')
      await context.dispatch('getProcessById', id)
    } catch (error) {
      console.error('Vuex - Action: updateStatus', error)
      throw error
    }
  },
  async getProcessById (context, id) {
    try {
      let processItem = await processRestService.getProcessById(id)
      processItem.date = toLocalDateInput(processItem.date)
      context.commit('setSelectedItem', processItem)
    } catch (error) {
      console.error('Vuex - Action: getProcessById', 'getProcessById', error)
      throw error
    }
  },
  setDialogActived (context, active) {
    context.commit('setDialogActived', active)
  },
  filterItems (context, filters) {
    context.commit('filterProcesses', filters)
  },
  refreshFilteredProcesses (context) {
    context.commit('refreshFilteredProcesses')
  }
}

const mutations = {
  setProcesses (state, data) {
    state.processes = data || []
    state.filteredProcesses = data || []
  },
  setDialogActived (state, active) {
    state.dialogActived = active
  },
  setSelectedItem (state, selectedItem) {
    state.selectedItem = selectedItem
  },
  filterProcesses (state, filters) {
    const processNumber = filters.processNumber == null || filters.processNumber === ''
      ? null
      : Number(filters.processNumber)
    const referenceName = (filters.referenceName || '').trim().toLocaleLowerCase()
    state.filteredProcesses = state.processes.filter(item => {
      const matchesNumber = processNumber === null || Number(item.processNumber) === processNumber
      const matchesName = !referenceName || (item.referenceName || '').toLocaleLowerCase().includes(referenceName)
      const matchesStatus = !filters.status || item.status === filters.status
      return matchesNumber && matchesName && matchesStatus
    })
  },
  refreshFilteredProcesses (state) {
    state.filteredProcesses = state.processes
  },
  setSelectedItemAsDefault (state) {
    state.selectedItem = state.defaultItem
  },
  setProcessNumberList (state, data) {
    state.processNumberList = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
